module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Thin.1843abb8ed4b82c593c5748a49e14905.eot";